import { isEqual } from 'lodash'

/**
 * Parse the encoded query value to string, or object/array
 * @param {String} query - Query value
 * @param {*} defaultVal - value to be returned if query is missing
 * @returns {*}
 */
function parseQuery(query, defaultVal = '') {
  const decodedQuery = decodeURI(query);
  
  if ([undefined, null, 'undefined'].includes(decodedQuery))
    return defaultVal;
  
  try {
    const value = JSON.parse(decodedQuery);
    if (typeof value === 'object') {
      return (Array.isArray(value))? [...value] : {...value}
    } else {
      return value;
    }
  } catch (e) {
    return decodedQuery;
  }
}

/**
 * Parses the entire url query object based on given default  
 * @param {Object} queries - The list of queries from the url
 * @param {Object} defaultVals - Default values to be based on 
 * @returns {Object}
 */
function parseQueries(queries, defaultVals) {
  if (typeof queries !== 'object' || !queries) return {};
  
  const parsedQueries = {};
  // The key value pair will be based on the properties of 
  // defaultValue and not the query to avoid missing data.
  for (const queryKey in defaultVals) {
    parsedQueries[queryKey] = parseQuery(queries[queryKey], defaultVals[queryKey])
  }
  return parsedQueries;
}


export default {
  /**
   * Add table filter to URL query
   * @param {Object} router 
   * @param {Object} route 
   * @param {Object} params 
  */
 addTableFilterQuery(router, route={}, params, paramDefaults = {}) {
   const oldQuery = route.query;
   let newQuery = {};
   
   // page
   const isDefaultPage = params.page === 1;
   const newPage = params.page != (oldQuery.page || 1);
   if (!isDefaultPage) newQuery.page = params.page;
   
   // other queries (filters, search, tab)
   let hasNewValue = 0;
   for (const paramKey in params) {
    const paramValue = params[paramKey] 
    const oldQueryValue = parseQuery(oldQuery[paramKey]) 
    const hasDefaullValue = Object.hasOwnProperty.call(paramDefaults, paramKey)
    const isParamObj = typeof paramValue === 'object' &&  paramValue !== null; 
    let isDefaultValue = false
    
    if (isParamObj) {
        const defaultValue =  hasDefaullValue 
          ? ( Array.isArray(paramDefaults[paramKey]) 
            ? [ ...paramDefaults[paramKey]] 
            : { ...paramDefaults[paramKey] }
          ) 
          : ''
        hasNewValue += !isEqual(paramValue, (oldQueryValue || defaultValue)) ? 1 : 0
        isDefaultValue = hasDefaullValue && isEqual(paramValue, paramDefaults[paramKey])
      } else {
        const defaultValue =  hasDefaullValue ? paramDefaults[paramKey] : ''
        hasNewValue += paramValue != (oldQueryValue || defaultValue) ? 1 : 0
        isDefaultValue = hasDefaullValue && paramValue == defaultValue
      }

      if (!isDefaultValue) newQuery[paramKey] = JSON.stringify(paramValue);
      
    }
  
    if (newPage || (hasNewValue > 0  && isDefaultPage)) {
      router.replace({
    		path: route.path,
    		query: newQuery,
    	}).catch(() => true);
    }
  },
  parseQuery,
  parseQueries,
}